export default "__VITE_ASSET__CCGB8X_D__"